import { cn } from '@/shared/lib/utils';

interface DisplayCardProps {
  className?: string;
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  date?: string;
}

function DisplayCard({ className, icon, title, description, date }: DisplayCardProps) {
  return (
    <div
      className={cn(
        "relative flex h-36 w-88 skew-y-[-8deg] select-none flex-col justify-between rounded-xl border border-default bg-muted/70 px-4 py-3 backdrop-blur-xs [grid-area:stack] after:absolute after:-right-1 after:top-[-5%] after:h-[110%] after:w-[20rem] after:bg-linear-to-l after:from-default after:to-transparent after:content-[''] *:flex *:items-center *:gap-2",
        className
      )}
    >
      <div>
        <span className="relative inline-block rounded-full bg-brand p-1">{icon}</span>
        <p className="text-lg font-medium text-strong">{title}</p>
      </div>
      <p className="whitespace-nowrap text-lg">{description}</p>
      <p className="text-subtle">{date}</p>
    </div>
  );
}

interface DisplayCardsProps {
  cards: DisplayCardProps[];
}

export default function DisplayCards({ cards }: DisplayCardsProps) {
  return (
    <div className="grid [grid-template-areas:'stack'] place-items-center motion-safe:animate-in motion-safe:fade-in-0 motion-safe:duration-700">
      {cards.map((cardProps, index) => (
        <DisplayCard key={index} {...cardProps} />
      ))}
    </div>
  );
}
